import { updateLessonCacheChirp } from '../lessons';
import { useGetHydratedTrackQuery } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/TrackChirpService.hooks';
export const useFullChirpTrack = trackId => {
  const {
    data,
    loading: trackLoading,
    error: trackError
  } = useGetHydratedTrackQuery({
    variables: {
      trackId
    },
    skip: trackId === null || isNaN(trackId) || !trackId,
    onCompleted(trackData) {
      trackData.result.track.lessons.forEach(lesson => {
        updateLessonCacheChirp(lesson);
      });
    }
  });
  return {
    track: data === null || data === void 0 ? void 0 : data.track,
    trackLoading,
    trackError
  };
};